import { Link, useLocation, useNavigate } from "react-router";
import { springConfigs, useReveal } from "../../../../../hooks/useReveal.jsx";
import { SanityImg } from "../../../../../lib/images.jsx";
import BlockContent from "../../BlockContent.jsx";
import { galleryStyles as styles } from "../../blockContent.css.js";
import DefaultPortal from "../../../../utils/DefaultPortal/DefaultPortal.jsx";
import IconButton from "../../../IconButton/IconButton.jsx";
import cx from "../../../../../lib/cx.js";

const BigView = ({ image }) => {
  const navigate = useNavigate();
  const off = (e) => {
    e.stopPropagation();
    navigate(".", { state: { showImgKey: undefined } });
  };
  return (
    <DefaultPortal>
      <div className={styles.container} onClick={off}>
        <div className={styles.onlyButton}>
          <IconButton
            onClick={off}
            name="xmark"
            theme={"dark"}
            size="45px"
            aria-label="Schließen"
          />
        </div>
        <SanityImg
          width={1200}
          height={800}
          asset={image.asset}
          className={styles.fullView}
        />
      </div>
    </DefaultPortal>
  );
};

const Tile = ({ image, showImgKey }) => {
  const reveal = useReveal(image._key === showImgKey && image.image.asset, {
    config: springConfigs.quickNoBounce,
  });
  return (
    <>
      <div
        className={cx(styles.tile, image.description ? styles.withShadow : "")}
      >
        <Link to="." state={{ showImgKey: image._key }}>
          {image.image.asset ? (
            <SanityImg
              width={400}
              asset={image.image.asset}
              className={styles.tileImg}
            />
          ) : (
            <div />
          )}
        </Link>
        {image.description && (
          <div className={styles.description}>
            <BlockContent content={image.description} textColor="white" />
          </div>
        )}
      </div>
      {reveal(() => (
        <BigView image={image.image} />
      ))}
    </>
  );
};

const GalleryBlock = ({ value }) => {
  const { images } = value;
  const { state } = useLocation();
  if (!images) return null; // No images provided; ignore

  const showImgKey = state?.showImgKey;
  return (
    <div className={styles.grid}>
      {images.map((img, idx) => (
        <Tile image={img} key={img._key || idx} showImgKey={showImgKey} />
      ))}
    </div>
  );
};

export default GalleryBlock;
